import { useEffect } from "react";
import { X } from "lucide-react";

/** Mobilde alttan açılan panel (tam ekran modal yerine uygulama hissi). */
export const BottomSheet = ({ open, onClose, title, testid = "bottom-sheet", children }) => {
  useEffect(() => {
    if (!open) return undefined;
    const onKey = (e) => e.key === "Escape" && onClose();
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [open, onClose]);

  if (!open) return null;
  return (
    <div className="md:hidden">
      <button
        aria-label="Kapat"
        data-testid={`${testid}-overlay`}
        onClick={onClose}
        style={{ zIndex: "var(--z-drawer)" }}
        className="fixed inset-0 bg-primary/40 backdrop-blur-sm"
      />
      <div
        data-testid={testid}
        style={{ zIndex: "calc(var(--z-drawer) + 1)" }}
        className="sheet-in fixed bottom-0 left-0 right-0 max-h-[88dvh] overflow-y-auto rounded-t-3xl border-t border-border bg-background"
      >
        <div className="sticky top-0 flex items-center justify-between border-b border-border bg-background px-4 py-3">
          <span className="mx-auto absolute left-1/2 top-1.5 h-1 w-10 -translate-x-1/2 rounded-full bg-border" />
          <p className="font-display text-base font-extrabold text-primary">{title}</p>
          <button
            onClick={onClose}
            data-testid={`${testid}-close`}
            aria-label="Kapat"
            className="app-tap -mr-2 flex h-10 w-10 items-center justify-center rounded-full text-muted-foreground"
          >
            <X className="h-5 w-5" />
          </button>
        </div>
        <div
          className="px-4 pt-3"
          style={{ paddingBottom: "calc(env(safe-area-inset-bottom) + 24px)" }}
        >
          {children}
        </div>
      </div>
    </div>
  );
};
